import { useContext } from "react";

import ThemeContext from "../../../context.ts";
import Context from "../../context.ts";

export default function useGetConnectCallback() {
	const { updateToken } = useContext(Context);
	const { state, isFrame } = useContext(ThemeContext);

	const redirectUrl = (token: string) =>
		`${state.redirectUri}?token=${token}&operation=${
			updateToken ? "UPDATE" : "CONNECT"
		}&entity=${state.entity?.id}&finished_by=SUCCESS`;

	const onConnect = (token: string) => {
		setTimeout(() => {
			if (isFrame) {
				if (window !== null && window.top !== null)
					window.top.postMessage({ type: "iframeUrl", token: token, finished_by: "SUCCESS" }, "*");
			} else window.location.href = redirectUrl(token);
		}, 2000);
	};

	return { onConnect };
}
